import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from '@app/services/error.service';
import { toParams } from '@shared/utils/query-to-params';
import { AssignmentGroupConfig } from '@data/models/assignment-group-config';
import { FilterParams } from '@claranet/node-search-filter';


export const ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT = '/one/v1/assignment-group-configurations';

@Injectable()
export class AssignmentGroupConfigService {

    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient,
    ) {
        this.errors = this.errorService.assignmentGroupConfigErrors;
    }

    public findAssignmentGroupsConfig(filterParams?: FilterParams): Observable<AssignmentGroupConfig[]> {
        const params = toParams(filterParams);
        return this.http.get<{ assignmentGroupConfigs: AssignmentGroupConfig[] }>(ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT, { params }).pipe(
            map((result) => result.assignmentGroupConfigs),
            catchError(this.errorService.errorHandler<AssignmentGroupConfig[]>(this.errors, 'Récupération des groupes d\'affectation', []))
        );
    }

    public getAssignmentGroupConfig(id: string): Observable<AssignmentGroupConfig> {
        return this.http.get<AssignmentGroupConfig>(`${ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT}/${id}`).pipe(
            catchError(this.errorService.errorHandler<AssignmentGroupConfig>(this.errors, 'Récupération du groupe d\'affectation', null))
        );
    }

    public createAssignmentGroupConfig(assignmentGroupConfig: AssignmentGroupConfig): Observable<AssignmentGroupConfig> {
        return this.http.post<AssignmentGroupConfig>(ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT, assignmentGroupConfig).pipe(
            map(created => new AssignmentGroupConfig(created)),
            catchError(this.errorService.errorHandler<AssignmentGroupConfig>(this.errors, 'Création du groupe d\'affectation', null))
        );
    }

    public updateAssignmentGroupConfig(id: string, assignmentGroupConfig: AssignmentGroupConfig): Observable<AssignmentGroupConfig> {
        return this.http.patch<AssignmentGroupConfig>(`${ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT}/${id}`, assignmentGroupConfig).pipe(
            map(updated => new AssignmentGroupConfig(updated)),
            catchError(this.errorService.errorHandler<AssignmentGroupConfig>(this.errors, 'Modification du groupe d\'affectation', null))
        );
    }

    public deleteAssignmentGroupConfig(id: string): Observable<AssignmentGroupConfig> {
        return this.http.delete<AssignmentGroupConfig>(`${ASSIGNMENT_GROUP_CONFIG_SERVICE_API_ROOT}/${id}`).pipe(
            map(deleted => new AssignmentGroupConfig(deleted)),
            catchError(this.errorService.errorHandler<AssignmentGroupConfig>(this.errors, 'Suppression du groupe d\'affectation', null))
        );
    }
}
